import React, { PropsWithChildren, useEffect } from 'react'
import { ITabContext, withTabContext } from './TabContext'

interface Props extends ITabContext {
  value: string
  label: string
  count?: number
  hidden?: boolean
}

function Tab(props: PropsWithChildren<Props>) {
  const { addTab, updateTab, activeTab, value, label, count, hidden, children } = props

  useEffect(() => {
    addTab({ value, label })
  }, [])

  useEffect(() => {
    updateTab(value, { label, count, hidden })
  }, [label, count, value, updateTab, hidden])

  if (value !== activeTab || hidden) {
    return null
  }
  return children
}

export default withTabContext(Tab)
